import UserHosRuleSet from "./UserHosRuleSet";
import { getKeys, getLatestRuleSet } from "../utils/helpers";
import { DriveStore } from "../store/reducers";
import Api from "../services/api";

export default class UserHosRuleSets {
    private userHosRuleSets: IIdDictionary<UserHosRuleSet> = {};
    private readonly store: DriveStore;

    constructor(store: DriveStore) {
        this.store = store;
    }

    get keys(): string[] {
        return getKeys(this.userHosRuleSets);
    }

    get length(): number {
        return this.keys.length;
    }

    fetch(api: Api) {
        let apiUser = api.getUser();
        let temp: IIdDictionary<UserHosRuleSet> = {};
        if (apiUser && apiUser.id){
            let storedRules = this.store.getState().userHosRuleSets[apiUser.id] || {};
            if (storedRules) {
                for (let id of getKeys(storedRules)) {
                    temp[id] = new UserHosRuleSet(storedRules[id]);
                }
            }
        }
        this.userHosRuleSets = temp;
    }

    add(userHosRuleSet: UserHosRuleSet) {
        this.userHosRuleSets[userHosRuleSet.id] = userHosRuleSet;
    }

    get(key: string): UserHosRuleSet {
        return this.userHosRuleSets[key];
    }

    getLatest(): UserHosRuleSet | undefined {
        return getLatestRuleSet(this.toArray());
    }

    getLatestRuleSetBeforeDate(logDate: Date): UserHosRuleSet | undefined {
        if (this.length <= 1) {
            return this.getLatest();
        }
        let beforeRulesets: UserHosRuleSet[] = [];
        for (const key of this.keys) {
            let ruleSet = this.userHosRuleSets[key];
            if (new Date(ruleSet.dateTime).getTime() <= logDate.getTime()) {
                beforeRulesets.push(this.userHosRuleSets[key]);
            }
        }
        return getLatestRuleSet(beforeRulesets);
    }

    getRulesetByDate(logDate: Date): UserHosRuleSet | undefined {
        if (this.length <= 1) {
            return this.getLatest();
        }
        let ruleSets: UserHosRuleSet[] = [];
        for (const key of this.keys) {
            let ruleSet = this.userHosRuleSets[key];
            if (new Date(ruleSet.dateTime).getTime() < logDate.getTime()) {
                ruleSets.push(ruleSet);
            }
        }
        return getLatestRuleSet(ruleSets);
    }

    toArray(): UserHosRuleSet[] {
        let keys = this.keys;
        let userHosRuleSetsJson = new Array(keys.length);
        for (let i = 0; i < keys.length; i++) {
            userHosRuleSetsJson[i] = this.userHosRuleSets[keys[i]].toJSON();
        }
        return userHosRuleSetsJson;
    }
}
export class UserHosRuleSetService {
    constructor(readonly store: DriveStore, readonly api: Api) { }
    /**
     * @param useNone Return string "None" instead of empty string on undefined HosRuleset
     * @returns latest HosRuleset from storage or empty string
     */
    getLatestHosRuleSetIdShortened(useNone = false): string {
        let rulesets = new UserHosRuleSets(this.store);
        rulesets.fetch(this.api);

        let latestRuleset = getLatestRuleSet(rulesets.toArray());
        if (latestRuleset?.hosRuleSet?.id) {
            return latestRuleset.hosRuleSet.id.replace("HosRuleSet", "");
        } else if (useNone) {
            return "None";
        } else {
            return "";
        }
    }

    isLatestRulesetCarrierExemption(): boolean {
        const ruleset = this.getLatestHosRuleSetIdShortened();
        return ruleset.toLowerCase().indexOf("carrierexemption") > -1;
    }
}